import { SDKLogger } from './types'

/** Log an error message with optional error object and metadata payload. */
export function logError(
  logger: SDKLogger | undefined,
  message: string,
  error?: unknown,
  meta?: Record<string, unknown>,
) {
  if (!logger?.error) {
    return
  }

  if (error !== undefined) {
    // common convention most loggers handle well:
    logger.error(error, message, meta)
  } else if (meta) {
    logger.error(message, meta)
  } else {
    logger.error(message)
  }
}
